/**
 * Link to delete
 *
 * Usage:
 * <ma-delete-button entity="entity" entry="entry" size="xs"></ma-delete-button>
 */
export default function ezyImpersonateDirective($state, $http, $cookies, ReadQueries) {
    return {
        restrict: 'E',
        scope: {
            entity: '&',
            entityName: '@',
            entry: '&',
            size: '@',
            label: '@',
        },
        link: function (scope, element, attrs) {
            scope.label = scope.label || 'Impersonate';
            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
            var stateParams = entityName == $state.params.entity ? { ...$state.params } : {};
            stateParams.entity = entityName;
            stateParams.id = scope.entry().identifierValue;
            scope.stateParams = stateParams;
            scope.impersonate = () => {
                ReadQueries.getOne(scope.entity(), 'ShowView', stateParams.id, 'ShowView', null).then((entry) => {
                    console.log(entry)
                  $http({
                        method: 'POST',
                        url: 'https://app.ezyinsights.com/api/user/' + entry.user_id + '/impersonate',
                        headers: {
                          'X-EzyInsights': $cookies.get('X-EzyInsights')
                        }
                    }).success((json, status, getHeaders, response) => {
                    $cookies.put('X-EzyInsights', json.token, {
                        domain: '.ezyinsights.com',
                    });
                    alert('Impersonated in the new tool');
                  });
                }).catch((err) => console.error(err))
            };
        },
        template:
` <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="impersonate(stateParams)">
<span class="glyphicon glyphicon-user" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>
</a>`
    };
}

ezyImpersonateDirective.$inject = ['$state', '$http', '$cookies', 'ReadQueries'];



// WEBPACK FOOTER //
// ./client/app/directives/ezyImpersonateButton.js